var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadLogoWaveform = function SvgFadLogoWaveform(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 128,
    cy: 128,
    r: 81
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.53 67.86A64.379 64.379 0 0 0 128.5 64a64.352 64.352 0 0 0-22.917 4.19 1317.969 1317.969 0 0 0 21.079 22.104c.77.79 2.042.806 2.831.038 0 0 12.798-12.235 21.038-22.472zm0 121.635a64.379 64.379 0 0 1-22.03 3.86 64.352 64.352 0 0 1-22.917-4.19 1956.097 1956.097 0 0 1 21.091-22.294 1.975 1.975 0 0 1 2.805-.041s12.812 12.428 21.052 22.665z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.907 76.531s-26.02 17.694-26.02 51.538c0 33.845 26.02 53.465 26.02 53.465l38.09-39.787 38.376 38.29s27.389-21.385 27.389-52.066c0-30.682-27.739-51.678-27.739-51.678l-25.672 26.32 13.39 13.837 13.112-11.68s6.936 10.757 7.035 23.153c.098 12.396-6.653 24.904-6.653 24.904l-39.191-38.937-37.495 38.69s-7.684-11.61-7.65-25.002c.035-13.393 7.008-24.966 7.008-24.966l12.75 12.488 14.996-12.609-27.746-25.96z",
    fill: "#FFF"
  }))));
};
export { SvgFadLogoWaveform as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-logo-waveform.42a088c3.svg";